import { render, staticRenderFns } from "./ServiceTypeBadge.vue?vue&type=template&id=1949d668&scoped=true&"
import script from "./ServiceTypeBadge.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeBadge.vue?vue&type=style&index=0&id=1949d668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949d668",
  null
  
)

export default component.exports